export const fsType = Object.freeze({FOLDER:0, FILE:1});